import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import { Language } from 'types/Language/Language';

export type LanguageType = Language[];

export async function getlanguageFromApi(): Promise<LanguageType> {
	// const response = await apiGetLanguage.callApi();
	// return response.getOrDefault([]);
	return [];
}

const rb = new ReducerBuilder<LanguageType>();
export const languageLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'language/LoadedFromBackend'
);

export const setReduxLanguages = rb.createActionForReducer(
	payloadReducer((x) => x),
	'language/SET'
);

export const languageReducer = rb.createReducer();
